module.exports = __webpack_public_path__ + "static/img/comparador-7-253a5bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconos/comparador-7.svg
// module id = kVJJ
// module chunks = 1